// extracted by mini-css-extract-plugin
module.exports = {"teachers":"index_teachers__1rsAB","title":"index_title__1VEBs","desc":"index_desc__1AFqF","content":"index_content__1biJR"};